var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('card',{staticClass:"col-sm-12 text-center mt-5"},[_vm._v(" procesando respuesta ... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }